import { takeLatest, put, call } from 'redux-saga/effects';

import { listPatrimonioCadastro } from '../service';
import {
  TABLE_PATRIMONIO_CADASTRO,
  TABLE_PATRIMONIO_CADASTRO_PENDING,
  TABLE_PATRIMONIO_CADASTRO_SUCCESS,
  TABLE_PATRIMONIO_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListPatrimonioCadastro(action) {
  yield put({ type: TABLE_PATRIMONIO_CADASTRO_PENDING })

  try {
    const table = yield call(listPatrimonioCadastro, action.args)
    yield put({ type: TABLE_PATRIMONIO_CADASTRO_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_PATRIMONIO_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListPatrimonioCadastro() {
  yield takeLatest(TABLE_PATRIMONIO_CADASTRO, sagaListPatrimonioCadastro)
}